var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTreeStructure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TreeStructure",
    clipPath: "url(#clip0_287_17160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 8.125H2.5C2.15482 8.125 1.875 8.40482 1.875 8.75V11.25C1.875 11.5952 2.15482 11.875 2.5 11.875H5C5.34518 11.875 5.625 11.5952 5.625 11.25V8.75C5.625 8.40482 5.34518 8.125 5 8.125Z",
    stroke: "#BDBDBD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.875 3.125H13.125C12.7798 3.125 12.5 3.40482 12.5 3.75V7.5C12.5 7.84518 12.7798 8.125 13.125 8.125H16.875C17.2202 8.125 17.5 7.84518 17.5 7.5V3.75C17.5 3.40482 17.2202 3.125 16.875 3.125Z",
    stroke: "#BDBDBD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.875 11.875H13.125C12.7798 11.875 12.5 12.1548 12.5 12.5V16.25C12.5 16.5952 12.7798 16.875 13.125 16.875H16.875C17.2202 16.875 17.5 16.5952 17.5 16.25V12.5C17.5 12.1548 17.2202 11.875 16.875 11.875Z",
    stroke: "#BDBDBD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.625 10H9.375",
    stroke: "#BDBDBD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.5 14.375H11.25C10.7527 14.375 10.2758 14.1775 9.92417 13.8258C9.57254 13.4742 9.375 12.9973 9.375 12.5V7.5C9.375 7.00272 9.57254 6.52581 9.92417 6.17417C10.2758 5.82254 10.7527 5.625 11.25 5.625H12.5",
    stroke: "#BDBDBD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_287_17160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeStructure);
export default __webpack_public_path__ + "static/media/TreeStructure.3cc8330880d820751db31c8760e20d24.svg";
export { ForwardRef as ReactComponent };